// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"54e6f02e1aaff0d7e91c","883":"444a93edaad2913c4898"}[chunkId] + ".js";
};